import { SliceComponentProps } from "@prismicio/react";
import { Slice } from "@prismicio/types";
import qs from "qs";
import React from "react";
import { QuoteUploadComponentSliceFragment } from "../../types/graphql";
import { IPageContext } from "../../types/types";
import { baseDomain } from "../../utils/constants";
import { origins } from "../../utils/environment-urls";
import { SharedSliceType } from "../shared-slice/shared-slice";
import UploadFilePanel, {
  IUploadFilePanelProps,
} from "../upload-file-panel/upload-file-panel";
import { LoadingPanelHome } from "../upload-file-panel/upload-file-panel.styled";
import {
  ContentWrapper,
  FullWidthCTABase,
  Heading,
  Image,
  QuoteCTABackground,
  QuoteCTATitle,
  UploadContentWrapper,
} from "./quote-upload.styled";
import * as FA from "../../styles/fontawesome";

type IQuoteUploadProps = Slice<
  SharedSliceType.quote_upload_component,
  QuoteUploadComponentSliceFragment["primary"]
> & { type: SharedSliceType };

const QuoteUpload = ({
  slice,
  context,
}: SliceComponentProps<IQuoteUploadProps, IPageContext>) => {
  const { heading, image, upload_component_heading, upload_component_cta } =
    slice.primary;

  const parsedUrl = qs.parse(`https://www.${baseDomain}/quoting/home/`);

  const queryProcess = Object.prototype.hasOwnProperty.call(
    parsedUrl,
    "process"
  )
    ? parsedUrl.process
    : "";

  const ctaButton = (
    <div>
      <i css={FA.CloudArrowUpSolid} />
      &nbsp;&nbsp;{upload_component_cta || "Choose file"}
    </div>
  );

  const children = (
    <QuoteCTABackground>
      <QuoteCTATitle>
        {upload_component_heading || "Drag & Drop to Start an Instant Quote"}
      </QuoteCTATitle>
      <QuoteCTATitle style={{ paddingLeft: 0 }}>OR</QuoteCTATitle>
    </QuoteCTABackground>
  );
  const LoadingSkeletonCard = () => <LoadingPanelHome />;
  const uploadProps = {
    panelStyle: "whiteSolid",
    processInitialism: queryProcess,
    segmentTrackPageSection: "home-hero",
    children: children,
    showSupportedFileTypes: true,
    showInstantQuoteButton: true,
    instantQuoteButtonContent: ctaButton,
    layoutDirection: "horizontal",
    showSecureBlurb: true,
    panelScale: "large",
    Fallback: LoadingSkeletonCard,
  } as IUploadFilePanelProps;

  return (
    <FullWidthCTABase>
      <ContentWrapper>
        {image && image.url && (
          <Image src={image.url} alt={image.alt || "Xometry Image"} />
        )}
      </ContentWrapper>
      <UploadContentWrapper>
        {heading && <Heading>{heading}</Heading>}
        <UploadFilePanel {...uploadProps} />
      </UploadContentWrapper>
    </FullWidthCTABase>
  );
};

export default QuoteUpload;
